import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MatNativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule, MatTreeNode } from '@angular/material/tree';
import { CustomDateAdapter } from '@case-management/app/shared/aggrid-components/custom-date-filter-component/custom-date-adapter';

const CASES_DATE_FORMAT = {
	parse: {
		dateInput: 'yyyy-MM-dd',
	},
	display: {
		dateInput: 'yyyy-MM-dd',
		monthYearLabel: 'MMM YYYY',
		monthYearA11yLabel: 'MMM YYYY',
		yearLabel: 'YYYY',
		yearA11yLabel: 'YYYY',
	},
};

export const MATERIAL_MODULES = [
	MatButtonModule,
	MatToolbarModule,
	MatCardModule,
	MatIconModule,
	MatTableModule,
	MatMenuModule,
	MatPaginatorModule,
	MatFormFieldModule,
	MatDividerModule,
	MatInputModule,
	MatDialogModule,
	MatSelectModule,
	MatProgressSpinnerModule,
	MatChipsModule,
	MatRadioModule,
	MatDatepickerModule,
	MatNativeDateModule,
	MatTreeModule,
	MatTreeNode,
	FormsModule,
	MatSidenavModule,
	MatTooltipModule,
	MatSnackBarModule,
];

@NgModule({
	declarations: [],
	imports: [...MATERIAL_MODULES],
	exports: [...MATERIAL_MODULES],
	providers: [
		{ provide: MAT_DATE_FORMATS, useValue: CASES_DATE_FORMAT },
		{ provide: DateAdapter, useClass: CustomDateAdapter },
	],
})
export class MaterialModule {}
